<template>
  <div class="wrap_wrap">
    <div class="wrap">
      <template>
        <div class="title">{{ $t("register.注册") }}</div>
      </template>
      <el-form ref="form" :model="form">
        <template>
          <div v-if="isCN">
            <el-form-item
              v-if="type === 'phone'"
              prop="phonenumber"
              :rules="[{ required: true, message: $t('register.请输入电话') }]"
            >
              <el-input
                :readonly="readonly"
                @focus="readonly = false"
                v-model="form.phonenumber"
                :placeholder="$t('register.电话')"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="type === 'email'"
              prop="email"
              :rules="[
                { required: true, message: $t('register.请输入Email') },
                { type: 'email', message: $t('index.格式不正确') },
              ]"
            >
              <el-input
                :readonly="readonly"
                @focus="readonly = false"
                v-model="form.email"
                :placeholder="$t('register.邮箱')"
              ></el-input>
            </el-form-item>
          </div>
          <div style="display: flex" v-else>
            <!-- <el-form-item
              v-if="type === 'phone'"
              prop="countrycode"
              :rules="[
                { required: true, message: $t('register.请输入国家编码') },
              ]"
              class="phone"
            >
              <i class="el-icon-plus"></i>
              <el-input
                :readonly="readonly"
                @focus="readonly = false"
                v-model="form.countrycode"
                :placeholder="$t('register.国家编码')"
                class="phone-code"
              ></el-input>
            </el-form-item>
            <span v-if="platform.isPC">&nbsp;</span>
            <el-form-item
              v-if="type === 'phone'"
              prop="phonenumber"
              class="phone"
              :rules="[{ validator: validatorTel }]"
            >
              <el-input
                :readonly="readonly"
                @focus="readonly = false"
                v-model="form.phonenumber"
                :placeholder="$t('register.电话')"
                class="phone-number"
              ></el-input>
            </el-form-item> -->
            <el-form-item
              v-if="type === 'email'"
              prop="email"
              :rules="[
                { required: true, message: $t('register.请输入Email') },
                { type: 'email', message: $t('index.格式不正确') },
              ]"
            >
              <el-input
                :readonly="readonly"
                @focus="readonly = false"
                v-model="form.email"
                placeholder="Email"
              ></el-input>
            </el-form-item>
          </div>
        </template>
        <el-form-item
          prop="code"
          :rules="[{ required: true, message: $t('register.请输入验证码') }]"
          class="form-item-code"
        >
          <el-input
            :readonly="readonly"
            @focus="readonly = false"
            v-model="form.code"
            :placeholder="$t('register.验证码')"
          ></el-input>
          <el-button
            class="code-btn"
            @click="onCodeBtnClick"
            :disabled="disabled"
          >
            {{ disabled ? `${count}s` : $t("register.获取验证码") }}
          </el-button>
        </el-form-item>
        <el-form-item
          class="form-item-password"
          prop="password"
          :rules="[{ validator: validatorPassword }]"
        >
          <el-input
            :readonly="readonly"
            @focus="readonly = false"
            v-model="form.password"
            type="password"
            show-password
            :placeholder="$t('register.密码')"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item-password" prop="referralCode" v-if="isCN">
          <el-input
            :readonly="readonly"
            @focus="readonly = false"
            v-model="form.referralCode"
            :placeholder="$t('forgotPass.邀请码(选填)')"
          ></el-input>
          <div class="extra" v-if="isCN">
            <div
              v-if="type === 'phone'"
              class="extra-item"
              @click="type = 'email'"
            >
              {{ $t("register.切换邮箱方式") }}
            </div>
            <div v-else class="extra-item" @click="type = 'phone'">
              {{ $t("register.切换手机号方式") }}
            </div>
          </div>
        </el-form-item>

        <!-- <div class="launchCampaign" v-if="form.launchCampaign">
          <p>please provide your address for delivery</p>
          <div style="display: flex; justify-content: space-between " >
            <el-form-item
            prop="consignee"
            class="consignee"
            :rules="rules=[{ required: true, message: '请输入收件人姓名' },]"
          >
            <el-input
              :readonly="readonly"
              @focus="readonly = false"
              v-model="form.consignee"
              
              :placeholder="'consignee'"
            ></el-input>
          </el-form-item>
            
            <el-form-item
              prop="postcode"
              class="postcode"
              :rules="[{ required: true, message: '请输入邮编' },]"
            >
              <el-input
                :readonly="readonly"
                @focus="readonly = false"
                v-model="form.postcode"
                :placeholder="'postcode'"
                
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            prop="address"
            :rules="rules=[{ required: true, message: '请输入收件人地址' },]"
          >
            <el-input
              :readonly="readonly"
              @focus="readonly = false"
              v-model="form.address"
              
              :placeholder="'address'"
            ></el-input>
          </el-form-item>

          <div style="display: flex; justify-content: space-between " >
            <el-form-item
              
              prop="city"
              :rules="[
                { required: true, message: '请输入城市' },
              ]"
              class="city"
            >
            
              <el-input
                :readonly="readonly"
                @focus="readonly = false"
                v-model="form.city"
                :placeholder="'city'"
              ></el-input>
            </el-form-item>
            
            <el-form-item
              prop="country"
              class="country"
              :rules="[{ required: true, message: '请输入国家' },]"
            >
              <el-input
                :readonly="readonly"
                @focus="readonly = false"
                v-model="form.country"
                :placeholder="'country'"
                
              ></el-input>
            </el-form-item>
          </div>
          <el-form-item
            prop="pointOfSale"
            
          >
            <el-input
              :readonly="readonly"
              @focus="readonly = false"
              v-model="form.pointOfSale"
              
              :placeholder="'where did you buy our products(optional)'"
            ></el-input>
          </el-form-item>
        </div> -->
        <el-form-item prop="launchCampaign" v-if="!isCN" >
          <el-checkbox v-model="form.launchCampaign" class="checkbox ">
            I participated in the Gowow European launch campaign
          </el-checkbox>
        </el-form-item>
        <el-form-item
          v-if="!isCN"
          prop="consent"
          :rules="[
            { validator: validatorConsent},
          ]">
          <el-checkbox v-model="form.consent" class="checkbox">
            I have read and agree to the
            <a href="/privacy" target="_blank" style="color: brown; text-decoration: underline;">Privacy Policy</a>
            and
            <a href="/terms" target="_blank" style="color: brown; text-decoration: underline;">Terms of service.</a>

          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button class="btn" @click="submit">
            {{ $t("register.确认") }}
          </el-button>
        </el-form-item>
      </el-form>

      <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%">
        <el-input
            :readonly="readonly"
            @focus="readonly = false"
            v-model="verificationCodeFrom"
            :placeholder="$t('register.验证码')"
        ></el-input>
        <el-button
            class="code-btn"
            @click="getCaptchaCode()"
            :disabled="disabled"
        >
          {{ verificationCode }}
        </el-button>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="sendVerify(verificationCodeFrom)">{{ $t("register.确认") }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {register, verificationCode, login, getCaptcha} from "@service/api";
import { mapState, mapActions } from "vuex";
import Message from "@utils/Message";
import { goto } from "@utils/goto";
import platform from "@utils/platform";
const id = window.location.search.split("=").pop();

export default {
  name: "App",
  components: {},
  data() {
    return {
      platform,
      readonly: true,
      type: "phone", // 'phone' | 'email'
      form: {
        code: "",
        email: "",
        phonenumber: "",
        countrycode: "",
        password: "",
        referralCode: "",
        // consignee: "",
        // address: "",
        // postcode: "",
        // city: "",
        // country: "",
        // pointOfSale: "",
        consent: "",
        launchCampaign: "",

      },
      disabled: false,
      count: 60,
      timeRef: null,
      nowlang: "",
      currentUrl: "",
      dialogVisible: false,
      verificationCode: "",
      verificationCodeFrom: "",
      captcha: "",
    };
  },
  watch: {

    type() {

      this.$refs.form.resetFields();
    },
    lang: function () {
      if (!this.isCN) {
        this.nowlang = localStorage.getItem(this.currentUrl);
        this.setLang(this.nowlang);
      }
    },
  },
  mounted() {

    this.form.referralCode = id;
    this.currentUrl = window.location.hostname + "nowlang";
    //每进入一个页面先获取当前存在localStorage的语言字段nowlang
    this.nowlang = localStorage.getItem(this.currentUrl);

    //url参数改变语言存入localStorage
    const langid = window.location.href.split("lang=")[1];
    if (langid) {
      localStorage.setItem(this.currentUrl, langid);
      this.nowlang = langid;
      this.setLang(this.nowlang);
      // console.log(this.nowlang);
    }

    setTimeout(() => {
      this.setLang(this.nowlang);
      //英文版注册页面默认为邮箱注册
      if(!this.isCN){
      this.type ="email";
      }
    }, 300);


  },
  computed: {
    ...mapState(["lang", "profile"]),
    isCN() {
      return this.lang === "zh-CN";
    },
  },
  beforeDestroy() {
    this.timeRef && clearInterval(this.timeRef);
  },
  methods: {
    ...mapActions(["setLang"]),
    validatorTel(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("register.请输入电话")));
        return;
      }
      const phoneReg = /^1[3456789][0-9]{9}$/;
      if (this.isZhCN && !phoneReg.test(value)) {
        callback(new Error(this.$t("order.格式不正确")));
        return;
      }
      // 非中文不验证电话
      callback();
    },
    validatorPassword(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("register.请输入密码")));
        return;
      }
      const phoneReg = /^[a-zA-Z\d!@#$%^&*]{8,20}$/;
      if (!phoneReg.test(value)) {
        callback(new Error(this.$t("register.请输入8-20位密码")));
        return;
      }
      callback();
    },
    validatorConsent(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("register.请阅读并同意隐私政策和服务条款")));
        return;
      }

      callback();
    },
    onCodeBtnClick() {
      if (!this.disabled) {
        const filed = this.type === "phone" ? "phonenumber" : "email";
        const value = this.form[filed];
        if (!value) {

          const msg = this.type === "phone" ? "请输入电话" : "请输入Email";
          Message.fail(this.$t(`register.${msg}`));
          return;
        }
        const params = { [filed]: value };
        if (this.type === "phone" && !this.isCN) {
          params.phonenumber =
            "+" + this.form["countrycode"] + this.form["phonenumber"];
          console.log(this.form["phonenumber"]);
        }
        if (this.type === "phone") {
          this.dialogVisible = true;
          this.generateCode()
        } else {
          this.verificationCodeAsync(params);
        }
      }
      if (this.type !== "phone") {
        this.codeCount();
      }
    },
    async getCaptchaCode() {
      try {
        const data = (await getCaptcha());
        this.captcha = data;
      } catch (e) {
        Message.fail(e);
      }
    },
    // 生成随机验证码
    generateCode() {
      const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let code = '';
      for (let i = 0; i < 4; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        code += chars.charAt(randomIndex);
      }
      this.verificationCode = code;
    },
    sendVerify(param) {
      if (param === this.verificationCode) {
        const filed = "phonenumber";
        const value = this.form[filed];
        if (!value) {

          const msg = "请输入电话";
          Message.fail(this.$t(`register.${msg}`));
          return;
        }
        const params = { [filed]: value };
        if (this.type === "phone" && !this.isCN) {
          params.phonenumber =
              "+" + this.form["countrycode"] + this.form["phonenumber"];
          console.log(this.form["phonenumber"]);
        }
        this.verificationCodeAsync(params);
        this.codeCount();
        this.dialogVisible = false;
      }
    },
    // 发送验证码
    async verificationCodeAsync(params) {
      try {
        await verificationCode(params);
      } catch (e) {
        Message.fail(e);
      }
    },
    codeCount() {
      this.disabled = true;
      this.count -= 1;
      this.timeRef = setInterval(() => {
        this.count -= 1;
        if (this.count < 1) {
          this.disabled = false;
          this.count = 60;
        }
      }, 1000);
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        try {
          const filed = this.type === "phone" ? "email" : "phonenumber";
          //不传递consent字段，所以conset字段单独取出
          const {consent, ...params} = { ...this.form, [filed]: undefined };
          //此处打印consent字段，用于避免未使用consent而eslint报错
          console.log(consent);
          await register(params);
          Message.success("注册成功");
          //自动登录
          const username =
            this.type === "phone" ? params.phonenumber : params.email;
          await login({
            username,
            password: params.password,
          });
          if (this.form.launchCampaign) {
            setTimeout(() => {
            goto("/personal", true);
          }, 500);
          }else{
            setTimeout(() => {
            goto("/editpersonal", true);
          }, 500);
          }

        } catch (e) {
          Message.fail(e);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@assets/styles/vars.scss";
@import "~@assets/styles/mixin.scss";
@import "~@assets/styles/func.scss";

// pc端
@media (min-width: $screen-md-min) {
  .wrap_wrap {
    width: 100vw;
    height: 100vh;
    @include flex-center();
  }
  .wrap {
    width: 668px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(199, 199, 199, 0.5);
    border-radius: 29px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 47px 0 40px;

    .title {
      margin-bottom: 25px;
      font-size: 35px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #000000;
    }

    .form-item-password {
      position: relative;
      .extra {
        margin-top: 9px;
        right: 0;
        position: absolute;
        font-family: PingFangSC-Regular;
        color: #7a7a7a;
        display: flex;
        align-items: center;
        line-height: 22px;
        .slide {
          margin: 0 10px;
        }
        .extra-item {
          cursor: pointer;
          font-size: 16px;
        }
      }
    }
    .launchCampaign {

      p {
        font-size: 15px;
        font-weight: 400;
        color: #000000;
        margin-bottom: 20px;
      }

    }
    .form-item-code {
      position: relative;
      .code-btn {
        width: 110px;
        position: absolute;
        right: 0;
        bottom: 0px;
        background: #000000;
        color: #ffffff;
        padding-left: 0;
        padding-right: 0;
      }
    }

    .btn {
      width: 457px;
      height: 66px;
      background: #000000;
      border-radius: 11px;
      font-size: 30px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #ffffff;
      margin-top: 20px;
    }
  }
  .wrap::v-deep {
    .el-form-item {
      margin-bottom: 30px;
    }

    .el-input__inner {
      width: 478px;
      height: 60px;
      border-radius: 11px;
      border: 1px solid #c3c3c3;
    }
  }
  .form-item-code::v-deep {
    .el-input__inner,
    .el-input {
      width: 300px;
    }
  }
  .phone::v-deep {
    .el-input__inner,
    .el-input {
      width: 300px;
    }
    .el-icon-plus {
      font-size: 20px;
      float: right;
      position: relative;
      right: 142px;
      top: 20px;
      z-index: 20;
    }
    .phone-code {
      width: 150px;
      .el-input__inner {
        width: 150px;
        padding-left: 30px;
      }
    }
  }
  // .country::v-deep {
  //   .el-input__inner,
  //   .el-input {
  //     width: 200px;
  //   }
  // }
  // .city::v-deep {
  //   .el-input__inner,
  //   .el-input {
  //     width: 200px;
  //   }
  // }
  // .consignee::v-deep {
  //   .el-input__inner,
  //   .el-input {
  //     width: 300px;
  //   }
  // }
  // .postcode::v-deep {
  //   .el-input__inner,
  //   .el-input {
  //     width: 150px;
  //   }
  // }
}

// m端
@media (max-width: $screen-md-min) {
  .wrap_wrap {
    width: 100vw;
    height: 100vh;
    @include flex-center();
    justify-content: flex-start;
    padding-top: px2rem2(200px);
    font-family: PingFang SC;
    color: #000000;
  }
  .wrap {
    width: px2rem2(700px);
    background: #ffffff;
    box-shadow: 0px 2px 12px 0px rgba(199, 199, 199, 0.5);
    border-radius: px2rem2(30px);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: px2rem2(60px) 0 px2rem2(74px);

    .title {
      margin-bottom: px2rem2(42px);
      font-size: px2rem2(36px);
      font-family: PingFangSC-Regular;
      font-weight: 500;
      color: #000000;
    }

    .form-item-password {
      position: relative;
      .extra {
        z-index: 20;
        margin-top: px2rem2(10px);
        right: 0;
        position: absolute;
        font-family: PingFangSC-Regular;
        color: #7a7a7a;
        display: flex;
        align-items: center;
        .slide {
          margin: 0 px2rem2(10px);
        }
        .extra-item {
          cursor: pointer;
          font-size: px2rem2(24px);
        }
      }
    }

    .form-item-code {
      position: relative;
      .code-btn {
        font-size: px2rem2(24px);
        width: px2rem2(176px);
        height: px2rem2(83px);
        background: #000000;
        border-radius: px2rem2(10px);
        position: absolute;
        right: 0;
        bottom: 0px;
        color: #ffffff;
        padding: 0;
        box-sizing: border-box;
      }
    }

    .btn {
      width: px2rem2(478px);
      height: px2rem2(71px);
      background: #000000;
      border-radius: px2rem2(10px);
      font-size: px2rem2(30px);
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: #ffffff;
      margin-top: px2rem2(30px);
    }
    .checkbox {

      width: px2rem2(478px);
      display:flex;
      align-items: center;

    }
  }
  .wrap::v-deep {
    .el-form-item {
      margin-bottom: px2rem2(42px);
    }
    .el-checkbox__label{
      white-space: normal;
    }
    .el-input__inner {
      width: px2rem2(478px);
      height: px2rem2(83px);
      border-radius: px2rem2(10px);
      border: 1px solid #c3c3c3;
    }
    .el-form-item__error {
      font-size: px2rem2(20px);
    }
  }
  .form-item-code::v-deep {
    .el-input__inner,
    .el-input {
      width: px2rem2(264px);
    }
  }
  .phone::v-deep {
    .el-input__inner,
    .el-input {
      width: px2rem2(238px);
      padding-right: 0;
    }
    .el-icon-plus {
      font-size: px2rem2(20px);
      font-weight: 700;
      float: right;
      position: relative;
      right: px2rem2(216px);
      top: px2rem2(30px);
      z-index: 20;
    }
    .phone-code {
      width: px2rem2(220px);
      .el-input__inner {
        width: px2rem2(220px);
      }
    }
  }
}
</style>
